import React from 'react';
import { icons } from '@ublend-npm/aulaui-next';

import { Provider, isKnownProvider } from './assignmentType';
import { EmptyLogoSpace } from './ProviderLogo.styled';
import { useAulaEditorContext } from '../../EditorContext';
import { LtiProviderIcon } from '../LtiProviderIcon/LtiProviderIcon';

export const providerToLogo = {
  [Provider.Handin]: icons.Handin,
  [Provider.Manual]: icons.SSA,
  [Provider.TurnitIn]: icons.TurnitIn,
  [Provider.Quizzes]: icons.Quiz,
};

type ProviderLogoProps = {
  provider: string;
  providerId?: string;
};

export const ProviderLogo = ({ provider, providerId }: ProviderLogoProps) => {
  const {
    config: { ltiProviders },
  } = useAulaEditorContext();

  if (!isKnownProvider(provider)) {
    return <EmptyLogoSpace data-testid="empty-logo" />;
  }

  if (provider === Provider.LTI1p3) {
    if (!ltiProviders || !providerId) {
      return <icons.ExtensionIcon />;
    }

    const ltiProvider = ltiProviders.find((prov) => prov.id === providerId);

    if (!ltiProvider || ltiProvider.ltiVersion !== '1.3') {
      return <icons.ExtensionIcon />;
    }

    const { iconUrl, description } = ltiProvider;

    return (
      <LtiProviderIcon iconUrl={iconUrl} altText={`${description} icon`} />
    );
  }

  const Logo = providerToLogo[provider];
  return <Logo />;
};
